import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';

const { EVENT_PRODUCT_INTERACTION } = eventNameConstants;
const { INTERACTION_TYPE_ITEM_FAVORITING } = interactionTypeConstants;
const { STEP_INTERACTION_SUCCESS_MESSAGE_DISPLAYED, STEP_INTERACTION_SUCCESS_MESSAGE_CTA_CLICKED } =
    stepInteractionConstants;

function trackItemFavoritingToast({
    trigger,
}: {
    trigger: 'favorited' | 'favorite removed' | 'foldered' | 'folder removed';
}): void {
    trackEvent({
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: INTERACTION_TYPE_ITEM_FAVORITING,
        step_interaction_name: STEP_INTERACTION_SUCCESS_MESSAGE_DISPLAYED,
        trigger,
    });
}

function trackItemFavoritingSuccessToastCtaClick({
    trigger,
}: {
    trigger: 'view favorites' | 'view folder';
}): void {
    trackEvent({
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: INTERACTION_TYPE_ITEM_FAVORITING,
        step_interaction_name: STEP_INTERACTION_SUCCESS_MESSAGE_CTA_CLICKED,
        trigger,
    });
}

export { trackItemFavoritingToast, trackItemFavoritingSuccessToastCtaClick };
